<template>
  <div class="pagenation">
    <ol>
      <li><a href="javascript:;" @click="goToPage(current_page - 1)" class="prev"
             :class="{'disabled': current_page === 1}"
             title="前のページ">
        <span class="material-icons">keyboard_arrow_left</span></a></li>
      <template v-if="last_page < 5">
        <li v-for="index in last_page" :key="index" :class="{active: index === current_page}"><a href="javascript:;"
                                                                                                   @click="goToPage(index)">{{
            index
          }}</a>
        </li>
      </template>
      <template v-else>
        <li v-for="(page,index) in getPaginationFormat" :key="index" :class="{active: page === current_page}">
          <a href="javascript:;" v-if="page !== '...'"
             @click="goToPage(page)">{{
              page
            }}</a>
          <template v-else>{{page}}</template>
        </li>
      </template>
      <li><a href="javascript:;" title="次のページ" class="next" @click="goToPage(current_page + 1)"
             :class="{'disabled': current_page === last_page}"><span
          class="material-icons">
            keyboard_arrow_right</span></a></li>
    </ol>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: ['current_page', 'last_page'],
  data() {
    return {
      delta: 2
    }
  },
  computed: {
    getPaginationFormat () {
      let pagination = []
      let left = this.current_page - this.delta
      let right = this.current_page + this.delta
      if(left > 1) {
        pagination.push(1)
        pagination.push('...')
      }
      let i = 1
      for (i; i <= this.last_page; i++) {
        if (i >= left && i <= right){
          pagination.push(i)
        }
      }
      if (right < this.last_page) {
        pagination.push('...')
        pagination.push(this.last_page)
      }
      return pagination
    }
  },
  methods: {
    goToPage(page) {
      if ((page > 0 || page < this.last_page) && page !== this.current_page) {
        this.current_page = page
        this.$emit('goToPage', page)
      }
    }
  }
}
</script>

<style scoped>

</style>